import * as React from 'react';

import { Intro } from '../../components/Intro';
import { useSelector } from 'react-redux';
import { selectFormattedTitle } from '../../../common/selectors/formattedTitle';
import { selectFormattedDate } from '../../../common/selectors/formattedDate';
import { useDeviceType } from '@cian/ui-kit';

export const IntroContainer: React.FC = () => {
  const titleForRender = useSelector(selectFormattedTitle);
  const dateForRender = useSelector(selectFormattedDate);

  const device = useDeviceType();

  return <Intro date={dateForRender} title={titleForRender} device={device} />;
};
